import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PromotionActions from 'redux/PromotionRedux';
import PayActions from 'redux/PayRedux';

function Refresher() {
  const dispatch = useDispatch();

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(PromotionActions.loadPromotions(true));
      dispatch(PayActions.loadCurrentTicket());
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return null;
}

export default Refresher;
